module.exports = __webpack_public_path__ + "static/external-ddcb21bfcb2d037c493fb7dcfb10cdda.jpg";